import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from '../../components/LoadableLoading';
import { ILoadedProps, IProps } from './interface';
import sortBy from 'lodash/sortBy';
import { getStaff, getPositions } from './api';
import { getOperations } from '../../api';

export const path = `/staff/list/`;

const PageStaffList: React.FC<IProps> = (props) => {
  const loader: any = {
    page: () => import(`./page`),
    i18n: () => import(`./ru.json`),
    positions: getPositions,
    staffList: getStaff,
    operations: getOperations,
  };

  const LoadableMap = Loadable.Map({
    loader,
    loading: LoadableLoading,
    render(loaded: ILoadedProps, loadedProps: {}): React.ReactNode {
      const Page: any = loaded.page.default;
      return (
        <Page
          {...loadedProps}
          {...props}
          positions={sortBy(
            loaded.positions.map((position) => ({
              value: position.positionId,
              label: position.positionName,
            })),
            'label',
          )}
          operations={loaded.operations}
          staffList={loaded.staffList}
          i18n={{ ...loaded.i18n }}
        />
      );
    },
  });

  return <LoadableMap {...props} />;
};

export default PageStaffList;
